import React from 'react';
import { RootState } from '@/store';
import { useAppSelector } from '@/hooks';
import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { AnimatePresence, motion } from 'framer-motion';
import { TranslatedText, useCleanPathname } from '@ianesthesie-kit/core';

export const ToolbarSlotsPerRoute = () => {
  const pathname = useCleanPathname();

  if (pathname?.startsWith('/questionnaire')) {
    return <QuestionCategorySlot />;
  }

  return null;
};

const selectCurrentCategory = (state: RootState) =>
  state.questionnaire.current?.[0]?.question?.category;

const QuestionCategorySlot = () => {
  const category = useAppSelector(selectCurrentCategory);

  return (
    <>
      <AnimatePresence mode="popLayout">
        {category && (
          <motion.div
            key={category}
            layout
            initial={{
              y: 40,
              scale: 0.5,
              opacity: 0,
              transformOrigin: 'center'
            }}
            animate={{ y: 0, scale: 1, opacity: 1 }}
            exit={{ y: 0 - 20, scale: 0.8, opacity: 0 }}
            transition={{ duration: 0.4, ease: 'easeOut' }}
          >
            <CategoryChip
              label={
                <TranslatedText
                  id={`patient-app.questionnaire.question.category.${category}`}
                />
              }
            />
          </motion.div>
        )}
      </AnimatePresence>
      {/* Dummy div with width matching drawer toggle button */}
      <div style={{ width: 40 }} />
    </>
  );
};

const CategoryChip = styled(Chip)`
  position: relative;
  top: 2px;
  background: white;
  color: ${(props) => props.theme.palette.primary.main};
  font-weight: 700;
  opacity: 0.85;
  * {
    text-overflow: unset !important;
  }
`;
